export enum DeviceTypes {
  POS = 1,
  PaymentTerminal = 2,
  Middleware = 4,
  Relay = 8,
  ExternalEntry = 16,
}
